import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a0971a04fe59d599f19353d2e0c757411b from "./generated-2e9302d4-0268-4c36-a5bc-72f8940edb05.json";

import ad7786f612a0b3e5088859625ccc9dc07b from "./generated-40466ebc-2b54-46d2-89e3-04dd0d0f0890.json";

import a0345e511f818c6cb1d77c5d829f84e0db from "./generated-ac5839d9-805b-498b-add1-5cc08945471e.json";

import adde76cc1e1947dd8b98af1de2b32261db from "./generated-d77385f4-f712-4deb-9126-8f2e62ae7819.json";

import a01663dfeb2faf4ab176a5827e0f39422b from "./generated-71a1eaf2-3395-4ea0-8397-1e39af0495d7.json";

import a6abb423529ccbc22643134f19c1a8b5cb from "./generated-a96e6137-6f9f-40bd-81ea-b851d161a29e.json";

import a04470fe0a09946798dd7cf52e421c082b from "./generated-71d2b4e4-96c6-4781-8985-5408103ff9fa.json";

import ab3445cb384355d0edba22befcaf0cdfbb from "./generated-25c93fd5-9527-4b47-9b5d-41d825d0ee89.json";

import a039f1bb3805dbf7caffb7994b8a8b2e0b from "./generated-46526a95-2c98-48bc-9302-232173e7444d.json";

import a7e5a6742a687b821b088515824cb5d6bb from "./generated-28725946-e7f8-42da-8d72-e0422bdf3a02.json";

import aabf83afe81bc3927f266710efe245783b from "./generated-a9881a4b-d81b-4cc3-af93-db4f0f3ca75f.json";

import a516609668ca5f10def1e28f42bb2049eb from "./generated-cb3309fa-3771-4f4a-bf6d-04a6bd9e3c59.json";

import a75d112cd921a52883e6b138ccdfcf242b from "./generated-68c9bf21-f06b-41bc-ba5f-1a326136fac7.json";

import a24bbf65ed12c4d6f89d6454f2d51920fb from "./generated-0f2198aa-0413-4acd-a29d-946e9308ccf8.json";

import a754036f06eca4e3a1dced3c299bc20b2b from "./generated-e1eba1f6-0455-4cbb-ac17-00146ad56471.json";

import ae16f424b1a7a4a38806ce6f4e036541db from "./generated-bfba694f-04c3-4571-98d7-2eb2ea73fcd6.json";

import a428ea83fb6eb05a0380011d7c7b4a37eb from "./generated-e5173701-e9ed-4ca4-9463-2cea251a46c2.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a0971a04fe59d599f19353d2e0c757411b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ad7786f612a0b3e5088859625ccc9dc07b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a0345e511f818c6cb1d77c5d829f84e0db);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(adde76cc1e1947dd8b98af1de2b32261db);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a01663dfeb2faf4ab176a5827e0f39422b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a6abb423529ccbc22643134f19c1a8b5cb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a04470fe0a09946798dd7cf52e421c082b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ab3445cb384355d0edba22befcaf0cdfbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a039f1bb3805dbf7caffb7994b8a8b2e0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a7e5a6742a687b821b088515824cb5d6bb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(aabf83afe81bc3927f266710efe245783b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a516609668ca5f10def1e28f42bb2049eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a039f1bb3805dbf7caffb7994b8a8b2e0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a75d112cd921a52883e6b138ccdfcf242b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a24bbf65ed12c4d6f89d6454f2d51920fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a039f1bb3805dbf7caffb7994b8a8b2e0b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a754036f06eca4e3a1dced3c299bc20b2b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ae16f424b1a7a4a38806ce6f4e036541db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a428ea83fb6eb05a0380011d7c7b4a37eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a754036f06eca4e3a1dced3c299bc20b2b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */